import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { formatRatingAverage } from 'helpers/formatters'

import classes from './FeatureWithRating.module.scss'

/** @type {import("./types").default} */
const FeatureWithRating = ({ feature, className, ...props }) => {
  const isDisabled = feature.global_feature_id === null
  const rating = !feature?.avg_rating || feature.avg_rating === 0 ? ' -- ' : formatRatingAverage(feature.avg_rating)
  return (
    <div className={clsx('FeatureWithRating', classes.root, { [classes.disabled]: isDisabled }, className)} {...props}>
      <Typography variant="tight-xxs" component="span">
        {feature.name}
      </Typography>
      <span className={classes.rating}>
        <Icon
          icon={isDisabled ? 'times' : 'star'}
          size="12"
          className={clsx(classes.icon, {
            [classes.star]: !isDisabled,
          })}
        />
        {!isDisabled && rating}
      </span>
    </div>
  )
}

export default FeatureWithRating
